import VideoTutorialsModalContent from './VideoTutorialsModalContent';

export default VideoTutorialsModalContent;
